import {api, handleApiError, ServiceResponse} from "../ApiClient";


export interface CaddieMaster {
    id: string
    clubId: string
    clubName: string
    approved: boolean
}

export interface CaddieMastersResponse extends ServiceResponse {
    caddieMasters?: CaddieMaster[]
}

export const CaddieMasterService = () => {

    const getForUser = (userId: string): Promise<CaddieMastersResponse> =>
        api.get<CaddieMaster[]>(`/api/1/caddiemasters?forUser=${userId}`)
            .then((resp) => {
            if (resp && resp.status === 200 && resp.data) {
                return {
                    caddieMasters: resp.data
                }
            }

            return {
                error: {
                    message: 'Could not get caddies for club.'
                }
            }
        })
            .catch(handleApiError)

    return {
        getCaddieMastersForUser: getForUser,
    }
}
